import React from 'react';
import { LucideIcon } from 'lucide-react';

interface ProjectTypeBadgeProps {
  icon: LucideIcon;
  label: string;
  bgColor: string;
  textColor: string;
}

export const ProjectTypeBadge: React.FC<ProjectTypeBadgeProps> = ({
  icon: Icon,
  label,
  bgColor,
  textColor
}) => {
  return (
    <div className={`px-3 py-2 ${bgColor} ${textColor} rounded-md flex items-center gap-2`}>
      <Icon className="h-4 w-4" />
      {label}
    </div>
  );
}; 